module.exports = __webpack_public_path__ + "static/media/virus (3).44e44451.png";